import FormSwitchSet from './FormCheckboxSet';
export default FormSwitchSet;
//# sourceMappingURL=FormSwitchSet.js.map